import {IApplicationError} from '../../api/interfaces/ApplicationError/IApplicationError';
import {IErrorTrace} from '../../api/interfaces/ApplicationError/IErrorTrace';
import {HttpErrorTrace} from './http.error.trace';
import { RequestMethod} from '@angular/http';

export class ServiceError  implements IApplicationError{
  private errorCode: number;
  private errorMessage: string;
  private errorTrace: IErrorTrace;

  constructor(errorCode: number, errorMessage: string, method: RequestMethod, url: string,  requestData: object, responseData: object = {})  {
    this.errorCode = errorCode;
    this.errorMessage = errorMessage;
    this.errorTrace = new HttpErrorTrace(method,  requestData, responseData, url);
  }

  getTrace() {
    return this.errorTrace;
  }

  getMessage() {
    return this.errorMessage;
  }

  getErrorCode() {
    return this.errorCode;
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/error/service.error.ts